import { request} from '@/utils';
import { BaseService } from './base.service';

export default class ComfirmOrderService extends BaseService{
  mockPrefixs:string;
  constructor(globalMock?:boolean){
    super();
    this.mockPrefixs = globalMock ? '/mock': '';
  }
  getPreOrder<T> (params: T) {
    return request.httpPost<T>(`${this.mockPrefixs}${this.tradePrefix}/buyer/order/v3/pre_order`, { params });
  }

  getPriceItems<T> (params: T) {
    return request.httpPost<T>(`${this.mockPrefixs}${this.tradePrefix}/buyer/order/v3/price_items`, { params });
  }

  createOrder<T> (params: T) {
    return request.httpPost<T>(`${this.mockPrefixs}${this.tradePrefix}/buyer/order/v3/create_order`, { params });
  }

  getExpressDefault<T> () {
    return request.httpGet<T>(`${this.mockPrefixs}${this.userPrefix}/buyer/v3/user/addresses`);
  }

  getUserPositionCity<T> () {
    return request.httpGet<any>(`${this.mockPrefixs}${this.homePrefix}/pub/v3/citys/current_location`);
  }
}
